import { NgModule } from '@angular/core';
import { SponsorEQueryTabsComponent } from './sponsor-e-query-tabs/sponsor-e-query-tabs.component';
import { EQueriesModule } from '../../e-queries/e-queries.module';
import { SponsorEQueriesStorage } from './sponsor-e-queries-storage';
import { SponsorEQueryRedirectionComponent } from './sponsor-e-query-tabs/sposnor-e-query-redirection.component';
import { SponsorEQueryGridComponent } from './sponsor-e-query-grid/sponsor-e-query-grid.component';
import { SharedModule } from '../../shared';
import { UserPermissionsModule } from '../../user-permissions/user-permissions.module';
import { CanSponsorViewEQueriesGuard } from './can-sponsor-view-e-queries-guard';
import { SponsorEQueriesCountersStorage } from './sponsor-e-queries-counters-storage';
import { SponsorAwaitingEQueriesComponent } from './awaiting/sponsor-awaiting-e-queries.component';
import { SponsorSubmittedEQueriesComponent } from './submitted/sponsor-submitted-e-queries.component';
import { SponsorEQueryColumns } from './sponsor-e-query-columns';
import {SponsorEQueryDetailsDialogComponent} from './e-query-details/sponsor-e-query-details-dialog.component';
import {GlobalPopupModule} from '../../global-popup';

@NgModule({
    declarations: [
        SponsorEQueryTabsComponent,
        SponsorEQueryRedirectionComponent,
        SponsorEQueryGridComponent,
        SponsorAwaitingEQueriesComponent,
        SponsorSubmittedEQueriesComponent,
        SponsorEQueryDetailsDialogComponent
    ],
    exports: [
        SponsorEQueryTabsComponent
    ],
    imports: [
        SharedModule,
        UserPermissionsModule,
        EQueriesModule,
        GlobalPopupModule
    ],
    entryComponents: [
    ],
    providers: [
         SponsorEQueriesStorage,
         CanSponsorViewEQueriesGuard,
         SponsorEQueriesCountersStorage,
         SponsorEQueryColumns
    ]
})
export class SponsorEQueryModule { }
